import WithdrawReport from "../../Component/Withdraw/WithdrawHistory/WithdrawReport"

const WithdrawReportPage = () => {
  return (
    <div className='page-body'>
      <WithdrawReport />
    </div>
  )
}

export default WithdrawReportPage